module.exports = __webpack_public_path__ + "static/media/logo-icon-dark-blue.61006f9e.svg";